import { render, staticRenderFns } from "./amccmembers.vue?vue&type=template&id=83ed97b2&scoped=true"
import script from "./amccmembers.vue?vue&type=script&lang=js"
export * from "./amccmembers.vue?vue&type=script&lang=js"
import style0 from "./amccmembers.vue?vue&type=style&index=0&id=83ed97b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83ed97b2",
  null
  
)

export default component.exports